/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Aditya's Portfolio",
  description:
    "Full-Stack Developer building scalable applications with Java, Spring Boot, React.js, PostgreSQL, Microservices, and secure REST APIs.",
  og: {
    title: "Aditya Kumar Singh Portfolio",
    type: "website",
    url: "https://adityasinghportfolia.in/",
  },
};

//Home Page
const greeting = {
  title: "Hi all, I'm Aditya",
  emoji: "👋",
  nickname: "Full-Stack Developer",
  logo_name: "AdityaKumarSingh",
  subTitle:
    "Full-Stack Developer with hands-on experience building and maintaining scalable applications using Java, Spring Boot, React.js, PostgreSQL, and REST APIs. Experienced in developing CRM, analytics, ticketing, inventory management, and business workflow systems, with a strong focus on backend architecture, API security, database optimization, and system performance. Skilled in managing end-to-end deployments across server infrastructure, Nginx, CI/CD, staging, and production environments, with practical experience in troubleshooting, scalability, and system reliability.",

  resumeLink: "/Aditya_Singh_Resume.pdf",
  portfolio_repository: "https://github.com/aditya9852/Portfolio",
  githubProfile: "https://github.com/aditya9852",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/aditya9852",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/adityasingh78/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "LeetCode",
    link: "https://leetcode.com/aditya_singh98/",
    fontAwesomeIcon: "simple-icons:leetcode",
    backgroundColor: "#FFA116",
  },
  {
    name: "CodeChef",
    link: "https://www.codechef.com/users/aditya_singh48",
    fontAwesomeIcon: "simple-icons:codechef",
    backgroundColor: "#5B4638",
  },
  {
    name: "Gmail",
    link: "mailto:aditya9852046@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/adityasingh926",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
];

const skills = {
  data: [
    {
      title: "Backend Development",
      fileName: "backend",
      skills: [
        "⚡ Build scalable services using Java, Spring Boot, REST APIs, and Microservices",
        "⚡ Secure APIs with Spring Security, JWT authentication, and role-based access control",
        "⚡ Design and optimize MySQL and PostgreSQL data models and queries",
        "⚡ Troubleshoot performance bottlenecks, connection pooling, and production reliability",
      ],
      softwareSkills: [
        { skillName: "Java", fontAwesomeClassname: "logos-java" },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:springboot",
        },
        {
          skillName: "Microservices",
          fontAwesomeClassname: "simple-icons:docker",
        },
        {
          skillName: "JWT",
          fontAwesomeClassname: "simple-icons:jsonwebtokens",
        },
        { skillName: "MySQL", fontAwesomeClassname: "simple-icons:mysql" },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "fullstack",
      skills: [
        "⚡ Develop responsive applications using React.js, Next.js, Redux, and JavaScript",
        "⚡ Build interfaces with HTML, CSS, Tailwind CSS, and Bootstrap CSS",
        "⚡ Integrate frontend applications with secure REST APIs and backend workflows",
      ],
      softwareSkills: [
        { skillName: "ReactJS", fontAwesomeClassname: "simple-icons:react" },
        { skillName: "NextJS", fontAwesomeClassname: "simple-icons:nextdotjs" },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
        },
        { skillName: "HTML5", fontAwesomeClassname: "simple-icons:html5" },
        { skillName: "CSS3", fontAwesomeClassname: "simple-icons:css3" },
        { skillName: "Redux", fontAwesomeClassname: "simple-icons:redux" },
      ],
    },
    {
      title: "Fintech & Real-World Systems",
      fileName: "fintech",
      skills: [
        "⚡ Developed Biompe – a biometric-based Payment system enabling phoneless transactions",
        "⚡ Designed secure transaction workflows and payment authorization systems",
        "⚡ Built biometric attestation mechanism for generating short-lived secure tokens",
        "⚡ Designed backend architecture ensuring security, scalability, and low-latency transactions",
        "⚡ Handled sensitive user data with secure encryption and validation mechanisms",
        "⚡ Focused on building real-world fintech solutions solving accessibility and usability problems",
      ],
      softwareSkills: [],
    },
    {
      title: "Problem Solving & Competitive Coding",
      fileName: "problemsolving",
      skills: [
        "⚡ Strong foundation in Data Structures & Algorithms",
        "⚡ Active on platforms like LeetCode & CodeChef",
        "⚡ Solved 600+ problems across arrays, graphs, DP, and system design patterns",
        "⚡ Strong understanding of time & space complexity optimization",
        "⚡ Experience in solving real-world problems using efficient algorithms",
        "⚡ Focus on writing optimized, clean, and scalable solutions",
        "⚡ Familiar with common patterns like sliding window, recursion, and backtracking",
        "⚡ Ability to break down complex problems into efficient logical steps",
      ],
      softwareSkills: [],
    },
    {
      title: "Deployment & Engineering Practices",
      fileName: "deployment",
      skills: [
        "⚡ Manage staging and production deployments on Ubuntu VPS infrastructure",
        "⚡ Configure Nginx, SSL, environment variables, PM2, and systemd services",
        "⚡ Automate build, release, validation, and rollback workflows with GitHub Actions",
        "⚡ Use Git for version control and Postman and Swagger for API testing and documentation",
      ],
      softwareSkills: [
        { skillName: "Git", fontAwesomeClassname: "simple-icons:git" },
        { skillName: "Docker", fontAwesomeClassname: "simple-icons:docker" },
        { skillName: "Postman", fontAwesomeClassname: "simple-icons:postman" },
        { skillName: "Swagger", fontAwesomeClassname: "simple-icons:swagger" },
      ],
    },
    {
      title: "Engineering Mindset",
      fileName: "engineering",
      skills: [
        "⚡ Focus on building real-world systems, not just projects",
        "⚡ Write clean, scalable, and maintainable code",
        "⚡ Follow modular architecture and separation of concerns",
        "⚡ Strong debugging and problem-solving approach",
        "⚡ Continuously improving in backend engineering and system design",
        "⚡ Passionate about learning new technologies and improving system performance",
        "⚡ Focus on writing production-ready and reusable code components",
        "⚡ Understand trade-offs between performance, scalability, and maintainability",
      ],
      softwareSkills: [],
    },
  ],
};
// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/aditya_singh98/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/adityakumarsin24",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/aditya_singh48",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/Aditya__Singh48",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@aditya7008/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Technocrats Institute of Technology & Science, Bhopal",
      subtitle: "B.Tech in Computer Science Engineering",
      logo_path: "tit.webp",
      alt_name: "TIT&S Bhopal",
      duration: "2021 - 2025",
      descriptions: [
        "⚡ CGPA: 8.34",
        "⚡ Studied core computer science subjects including Data Structures & Algorithms, DBMS, Operating Systems, and Computer Networks",
        "⚡ Developed strong problem-solving skills and understanding of time & space complexity through continuous practice",
        "⚡ Specialized in backend development using Java, Spring Boot, and Microservices architecture",
        "⚡ Built real-world applications including Biompe – a biometric-based UPI payment system enabling phoneless transactions",
        "⚡ Gained hands-on experience in REST API development, authentication systems (JWT, OTP), and database design",
        "⚡ Actively improving system design and backend engineering skills alongside academic curriculum",
      ],
      website_link: "https://technocratsgroup.edu.in",
    },
    {
      title: "DAV Public Sr. Sec. School, Bina (UP)",
      subtitle: "Senior Secondary (12th - CBSE)",
      logo_path: "school.jpg",
      alt_name: "DAV Bina",
      duration: "2020",
      descriptions: [
        "⚡ Percentage: 84.6%",
        "⚡ Strong foundation in Mathematics, Physics, and logical reasoning",
        "⚡ Developed analytical thinking and structured problem-solving approach",
        "⚡ Built early interest in computer science and technology",
      ],
      website_link: "",
    },
    {
      title: "DAV Public Sr. Sec. School, Bina (UP)",
      subtitle: "Secondary (10th - CBSE)",
      logo_path: "school.jpg",
      alt_name: "DAV Bina",
      duration: "2018",
      descriptions: [
        "⚡ Percentage: 91%",
        "⚡ Developed strong academic foundation with focus on science and mathematics",
        "⚡ Built discipline, consistency, and problem-solving mindset",
        "⚡ Participated in academic activities and strengthened logical thinking skills",
      ],
      website_link: "",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work & Practical Experience",
  description:
    "Hands-on experience building and maintaining production-ready full-stack applications, scalable backend services, and secure REST APIs using Java, Spring Boot, React.js, and PostgreSQL. I have delivered CRM, analytics, ticketing, inventory, asset tracking, and business workflow systems while improving database performance, API security, and application reliability. My work also includes troubleshooting production issues and managing end-to-end deployments across Ubuntu servers, Nginx, CI/CD pipelines, staging, and production environments.",
  header_image_path: "experience.webp",

  sections: [
    {
      title: "Professional Experience",
      experiences: [
        {
          title: "Research & Tech Specialist",
          company: "C Prompt Solutions Private Limited",
          company_url: "",
          logo_path: "cprompt-solutions-logo.png",
          duration: "May 2025 - Present",
          location: "Hyderabad",
          description: [
            "Developed and maintained enterprise full-stack applications for 5+ business functions using Java, Spring Boot, React.js, PostgreSQL, and REST APIs",
            "Delivered CRM, analytics, ticketing, asset tracking, and process optimization solutions supporting 30,000+ records",
            "Implemented secure services with Spring Security, JWT authentication, REST APIs, role-based access control, and granular permission models",
            "Optimized API performance, PostgreSQL queries, N+1 bottlenecks, connection pooling, and frontend data fetching",
            "Unified 7+ business processes across sales, inventory, approvals, engagement operations, service requests, equipment tracking, and reporting",
            "Administered live infrastructure using Ubuntu VPS, Nginx, SSL, Git, PM2/systemd, and automated delivery pipelines",
          ],
          color: "#0b2b5b",
        },
      ],
    },
    {
      title: "Internships",
      Internships: true,
      experiences: [
        {
          title: "Python Developer Intern",
          company: "Timoz Digital Era Pvt Ltd",
          company_url: "",
          logo_path: "timoz_logo.png", // ✅ make sure file exists
          duration: "Oct 2024 – Dec 2024",
          location: "Bangalore",
          description: [
            "Collaborated with UI/UX and QA teams on a Django-based real-time visualization system serving 10,000+ users",
            "Developed an image-processing pipeline with Python, OpenCV, and NumPy",
            "Achieved approximately 95% rendering accuracy for dynamic previews",
            "Improved testing and code-review practices, reducing production bugs by 90%",
          ],
          color: "#000000",
        },
      ],
    },
    {
      title: "Freelancing",
      experiences: [
        {
          title: "Backend Developer",
          company: "Self-Employed",
          company_url: "",
          logo_path: "freelance_logo.png", // ✅ will use fallback UI
          duration: "Jan 2023 - April 2026",
          location: "Remote",
          description: [
            "Built scalable backend systems using Spring Boot and REST APIs",
            "Implemented secure authentication using JWT and role-based access control",

            "🚨 SECURITY INCIDENT HANDLING (PRODUCTION SYSTEM)",
            "Detected unauthorized crypto-mining activity affecting server performance",
            "Analyzed server logs and identified malicious processes consuming resources",
            "Removed injected scripts and secured backend endpoints",
            "Prevented further exploitation by strengthening application security",

            "Optimized database queries and improved system performance",
            "Worked on real-world applications focusing on scalability and reliability",
          ],
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I design and build scalable, production-ready applications that solve practical business and user problems. My projects combine Java, Spring Boot, React.js, PostgreSQL, secure REST APIs, and microservices architecture with a strong focus on performance, reliability, and maintainability. I also implement authentication, database optimization, deployment automation, CI/CD, health monitoring, release management, and rollback workflows to support applications from development through staging and production.",
  avatar_image_path: "project.webp",
};

const projects = [
  {
    title: "ServerLaunch - Deployment Automation & VPS Management Platform",
    problem:
      "Manual deployments across different application stacks are slow, inconsistent, and difficult to recover when a release fails.",
    objective:
      "Build a secure platform that automates application deployment, environment configuration, health validation, release promotion, and rollback across Linux and Windows servers.",
    impact: [
      "Reduced deployment time from 20-30 minutes to approximately 3 minutes for staging and 2 minutes for production",
      "Supported 7+ application stacks including Java, Node.js, Python, PHP, .NET, Docker, and static applications",
      "Added GitHub-based CI/CD, multi-tenant isolation, real-time logs, release history, and health monitoring",
      "Enabled rapid recovery by rolling applications back to previous stable releases",
    ],
    tech: ["Java", "Spring Boot", "React.js", "PostgreSQL", "GitHub Actions", "CI/CD"],
    github: "#",
    demo: "https://serverlaunch.in/",
  },
  {
    title: "Phone-less Biometric UPI Payment System",
    problem:
      "UPI payments depend on smartphones, PINs, and personal devices, limiting accessibility for elderly users and people in rural or low-connectivity areas.",
    objective:
      "Build a secure payment platform that authorizes transactions through fingerprint verification, short-lived tokens, UPI AutoPay, and independently deployable services.",
    impact: [
      "Reduces dependency on smartphones and PIN-based payment authorization",
      "Improves accessibility for elderly, rural, and low-connectivity users",
      "Protects payment data using biometric attestation and short-lived tokens",
      "Supports validation, duplicate-payment prevention, failure handling, and audit records",
      "Improves scalability and fault isolation through independent payment services",
      "Creates a foundation for assisted and offline-first payment experiences",
    ],
    tech: ["Java", "Spring Boot", "Microservices", "MySQL", "JWT", "UPI AutoPay"],
    github: "#",
    demo: "#",
  },
  {
    title: "Secure Share with Face Guard Encryption",
    problem:
      "Conventional file-sharing systems rely on weak authentication mechanisms like links or passwords, making them vulnerable to unauthorized access and data breaches.",
    objective:
      "Design a secure file-sharing platform combining AES-256 encryption with facial recognition-based authentication to ensure identity-based access control.",
    impact: [
      "Achieves 97% biometric authentication accuracy for reliable identity verification",
      "Reduces unauthorized access attempts by 90% through face-based authentication",
      "Prevents 95% of potential data breaches using strong encryption mechanisms",
      "Strengthens data protection with secure key management and encrypted storage",
    ],
    tech: ["Python", "OpenCV", "Django", "AES-256"],
    github: "#",
    demo: "https://aditya38654.pythonanywhere.com/",
  },
  {
    title: "Smart Expense Tracker & Admin Dashboard",
    problem:
      "Existing expense tracking applications lack scalability, centralized analytics, and real-time insights for effective financial management.",
    objective:
      "Develop a microservices-based expense tracking system with an admin dashboard to manage, categorize, and analyze financial data in real time.",
    impact: [
      "Reduces API response time by 40% through optimized backend processing",
      "Provides real-time financial insights for improved decision-making",
      "Handles large datasets efficiently using scalable architecture",
      "Enhances user experience with structured dashboards and analytics",
    ],
    tech: ["Spring Boot", "React", "PostgreSQL"],
    github: "#",
    demo: "https://expensetracker73.netlify.app/",
  },
];
// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "aditya-photo.webp",
    description:
      "Full-Stack Developer specializing in Java, Spring Boot, React.js, PostgreSQL, Microservices, REST APIs, deployment automation, and production-ready business systems.",
  },
  addressSection: {
    title: "Address",
    subtitle: "Hyderabad, India",
    locality: "Hyderabad",
    country: "India",
    region: "Telangana",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+91 9555546971",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  experience,
  projectsHeader,
  projects,
  contactPageData,
};
